import reportConstants from "../../constants"
import { getCompletedStopStatus } from "../../util"
const getStopStatusDetails = (stopStatus) => {
  if (stopStatus === reportConstants.DISPATCH_STOP_STATUS_TYPES.ONTIME) {
    return {
      stopStatus: "Made Standard",
      stopStatusClass: "noViolation",
    };
  }
  return {
    stopStatus: "Missed Standard",
    stopStatusClass: "violation",
  };
};

const getStopDetails = (data) => {
  const completedStopStatus = getCompletedStopStatus(data);
  return getStopStatusDetails(completedStopStatus);
};

export { getStopDetails };
